import styles from './styles.module.css';
import globalStyles from '../../styles/global.module.css';
import React from 'react';

interface QuestionListProps {
    title: string;
    items: string[];
}

const QuestionList = (props: QuestionListProps) => {
    const { title, items } = props;

    return (
        <div className={styles.questionsList}>
            <span className={`${globalStyles.text} ${globalStyles.textBold}`}>
                {title}
            </span>
            <ul>
                {items.length===1 &&
                    <span className={`${globalStyles.text}`}>
                                {items[0]}
                    </span>
                }
                {items.length>1 && items.map((item, index) => {
                    return (
                        <li key={`question_item_${index}`}>
                            <span className={styles.itemList}>
                                {item}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default QuestionList;
